module.exports = __webpack_public_path__ + "img/Info-lady.5ceacc03.svg";